module.exports = function() {
  return new Worker(__webpack_public_path__ + "c19757b966e00b2213ba.worker.js");
};